import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import ModalLink from 'brastrap/common/modal/ModalLink';
import EditorialContainer from 'brastrap/editorial/editorial-container/EditorialContainer';
import Icon from 'brastrap/common/icon/Icon';

import { SIZE_GUIDE_SLUG } from '../ProductPageContainer';
import { openLayer, closeLayer } from '../../../../actions/layer';

const messages = defineMessages({
  title: {
    id: 'briefs-size-guide.title',
    defaultMessage: 'Bottoms size guide',
  },
});

const modalId = 'briefs-size-guide.modal';

const BriefsSizeGuide = ({
  content,
  intl: { formatMessage },
  onModalOpen,
  onModalClose,
  isOpen,
}) => (
  <ModalLink
    {...{
      onModalOpen,
      onModalClose,
      isOpen,
      label: formatMessage(messages.title),
    }}
    modal={{ modifiers: ['briefs-size-guide'] }}
    modalId={modalId}
    url="/briefs-size-guide/"
    ariaLabel="Open bottoms size guide"
    icon={
      <Icon className={'briefs-size-guide__icon'} icon={'size-guide-briefs'} />
    }
  >
    <EditorialContainer containers={content} />
  </ModalLink>
);

BriefsSizeGuide.propTypes = {
  content: PropTypes.array.isRequired,
  intl: intlShape,
  isOpen: PropTypes.bool,
  onModalClose: PropTypes.func,
  onModalOpen: PropTypes.func,
};

const mapStateToProps = ({ content, layer: { target, isVisible } }) => ({
  content: (content.data && content.data[SIZE_GUIDE_SLUG]) || [],
  isOpen: target === modalId && isVisible,
});

const mapDispatchToProps = dispatch => ({
  onModalClose: () => dispatch(closeLayer()),
  onModalOpen: target => dispatch(openLayer(target)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(BriefsSizeGuide));
